import { ReactComponent as Feedback } from "assets/Feedback.svg";
import { ReactComponent as MyListsIcon } from "assets/ListIcon.svg";
import { ReactComponent as ManageSuggestionIcon } from "assets/ManageSuggestionIcon.svg";
import { ReactComponent as DashboardIcon } from "assets/MenuIcons/dashboard.svg";
import { ReactComponent as SettingsMenu } from "assets/Settings.svg";
import { ReactComponent as LibraryIcon } from "assets/searchicon.svg";
import { ReactComponent as MyPlansIcon } from "assets/write.svg";
import { isEmpty } from "lodash";
import { RootState } from "redux/store";
import { abovePropUserView } from "utils/CommonConstants";
import { getPlansRoute } from "utils/StoreUtils";
import { leftNavItems, recommendationAccessTypes } from "utils/Types";
import { routes } from "utils/routes";

export const NavbarItems = (state: RootState) => {
  const { isAbovePropertyUser, manageFeedbackAccess, isCorp } = state.app.loggedInUserDetails;
  const homeTitle = isAbovePropertyUser ? leftNavItems.myDashboard : leftNavItems.home;
  const homeTitleForCorp = state.app.loggedInUserDetails.isConsultant
    ? leftNavItems.corporateDashboard
    : leftNavItems.dashboard;
  const myDashboardLink = isAbovePropertyUser ? "/?parentTab=Hotel+View" : "/";
  const route = getPlansRoute();
  const myPlanLink = isAbovePropertyUser ? "/myplans?parentTab=Property+Plans" : route;
  return [
    {
      label: homeTitle,
      link: myDashboardLink,
      icon: DashboardIcon,
      getPaths: () => {
        return ["", "property", "planProgress", "userview", "userDashboard"];
      },
      shouldDisplay: () => {
        return !state.app.loggedInUserDetails.isCorp;
      }
    },
    {
      label: homeTitleForCorp,
      link: "/",
      icon: DashboardIcon,
      getPaths: () => {
        return ["", "property", "userview"];
      },
      shouldDisplay: () => {
        return state.app.loggedInUserDetails.isCorp && !state.app.loggedInUserDetails.isConsultant;
      }
    },
    {
      label: leftNavItems.myLists,
      link: "/?tab=Properties",
      icon: MyListsIcon,
      getPaths: () => {
        return ["myLists", "", "progressInfo"];
      },
      shouldDisplay: () => {
        return state.app.loggedInUserDetails.isConsultant;
      }
    },

    {
      label: leftNavItems.corporateDashboard,
      link: `${routes.CorporateDashboard}?tab=Properties`,
      icon: DashboardIcon,
      getPaths: () => {
        return ["CorporateDashboard", "property", "userview"];
      },
      shouldDisplay: () => {
        return state.app.loggedInUserDetails.isConsultant;
      }
    },
    {
      label: leftNavItems.library,
      link: "/library?tab=All+Plans+",
      icon: LibraryIcon,
      getPaths: () => {
        return ["library", "plandetails", "functionalArea"];
      },
      shouldDisplay: () => {
        return true;
      }
    },
    {
      label: leftNavItems.myLists,
      link: "/myLists?tab=Properties",
      icon: MyListsIcon,
      getPaths: () => {
        return ["myLists"];
      },
      shouldDisplay: () => {
        return (
          (state.app.loggedInUserDetails.isCorp && !state.app.loggedInUserDetails.isConsultant) ||
          (isAbovePropertyUser && state.app.viewAsForAbovePropUser === abovePropUserView["AP"])
        );
      }
    },
    {
      label: leftNavItems.myPlans,
      link: myPlanLink,
      icon: MyPlansIcon,
      getPaths: () => {
        return isCorp
          ? ["inncodeplans", "myplandetails", "inncodeplandetails", "templateplandetails"]
          : ["myplans", "myplandetails", "templateplandetails"];
      },
      shouldDisplay: () => {
        return true;
      }
    },

    {
      label: leftNavItems.manageSuggestions,
      icon: ManageSuggestionIcon,
      link: routes.ManageSuggestions,
      getPaths: () => {
        return ["managesuggestions"];
      },
      shouldDisplay: () => {
        return (
          state.app.loggedInUserDetails.uploadRecommendationAccess !== recommendationAccessTypes.disabled &&
          !state.app.impersonationDetails.isImpersonated
        );
        return true;
      }
    },
    {
      label: leftNavItems.adminConsole,
      link: "/adminconsole",
      icon: SettingsMenu,
      getPaths: () => {
        return ["adminconsole", "editPermission"];
      },
      shouldDisplay: () => {
        return state.app.loggedInUserDetails.adminConsoleAccess && !state.app.impersonationDetails.isImpersonated;
      }
    },
    {
      label: leftNavItems.feedback,
      link: routes.Feedback,
      icon: Feedback,
      getPaths: () => {
        return ["feedback", "editfeedback"];
      },
      shouldDisplay: () => {
        return (
          (state.app.loggedInUserDetails.isCorp || state.app.loggedInUserDetails.isConsultant) &&
          manageFeedbackAccess !== "Disabled" &&
          !isEmpty(manageFeedbackAccess)
        );
      }
    }
  ];
};
